import { React } from "react";
import useGetLogById from "../../hooks/useGetlogById";
import DiscussionThread from "./DiscussionThread";
import MessageSender from "./MessageSender";

const DiscussionPanel = ({ logId, userId, parentType, stateTransition, refresh, readOnly, createDate }) => {
  const { data, error, loaded } = useGetLogById(logId, refresh);
  const formattedDate = createDate ? new Date(createDate).toLocaleString("fr-FR") : null;

  return (
    <div>
      <div className="pt-2">
        <h6>
          <i className="bx bx-history thread-header-icon"></i> Historique
        </h6>
        <div
          style={{
            backgroundColor: "#d9edf7",
            color: "#31708f",
            padding: "8px 12px",
            borderRadius: 4,
            marginBottom: 10,
            fontStyle: "italic",
            fontSize: 14,
            border: "1px solid #bce8f1",
          }}
          className="admin-message"
        >
          {formattedDate
            ? `Date de création du DigDay : ${formattedDate}`
            : "Pas de date de création disponible pour ce DigDay."}
        </div>
      </div>
      {!loaded ? (
        <span>chargement...</span>
      ) : data ? (
        <div>
          {!readOnly && <MessageSender parentId={logId} parentType={parentType} />}
          <hr />
          <DiscussionThread log={data} userId={userId} stateTransition={stateTransition ?? undefined} />
        </div>
      ) : (
        <div>
          <span>
            <i>La récupération des données a échoué !</i>
          </span>
        </div>
      )}
    </div>
  );
};

export default DiscussionPanel;